import api from '@/apis/di/accountAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('account', api);
import store from '@/stores/store';
import { ModuleAccountCombo, ModuleDefaultAccountCache, ModuleAutoBusinessCache } from '@/stores/moduleConst';

const state = {
  ...crud.state,
  _config: {
    table: 'di_account',
    field: {
      key: 'account_id',
      code: 'account_number',
      name: 'account_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Load tree
   */
  async loadTree(context, payload) {
    let res = null;

    try {
      context.commit('updateLoading', true);
      res = await api.getTree(payload || {});
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      //sắp xếp ở đây giảm cho server
      res = res.sortObject('account_number');
      context.commit('setItems', res);
      // dtnga3 (12.05.2023) load lại dữ liệu combo tài khoản
      if (payload.customPayload?.isUpdateAccountCombo) {
        store.dispatch(`${ModuleAccountCombo}/setItemsCombo`, res);
      }
    }

    return res;
  },

  /**
   * Override cập nhật số dư tài khoản
   * NTLOC 11.07.2022
   * @param {*} context
   * @param {*} payload
   * @returns
   */
  async updateTranferAccountData(context, payload) {
    let res = await api.updateTranferAccountData(payload || {});
    if (res) {
      if(res.data.ToData){
        res.data.ToData.old_account_number_reference = payload.FromData?.account_number;
        res.data.ToData.is_tranfer_data = true;
      }

      if (payload.State == 0) {
        context.commit('insertItem', res.data.ToData);
      } else if (payload.State == 1) {
        context.commit('updateItem', res.data.ToData);
      }

      // dtnga3 (12.05.2023) Cập nhật tài khoản cha (nếu có)
      if (payload.FromData && payload.FromData.state == 1) {
        delete res.data.ToData?.is_tranfer_data;
        payload.FromData.is_update_parent = true;
        context.commit('updateItem', payload.FromData);
      }
    }
    return res;
  },

  /**
   * Thêm mới
   */ async insert(context, payload) {
    let res = await api.insert(payload);
    if (res) {
      res.old_account_number_reference = payload.old_account_number_reference;
      //cập nhật danh sách
      context.commit('insertItem', res);
    }
    return res;
  },
  /**
   * Cập nhật
   */ async update(context, payload) {
    let res = await api.update(payload);
    if (res) {
      res.old_account_number_reference = payload.old_account_number_reference;
      //cập nhật danh sách
      context.commit('updateItem', res);
    }
    return res;
  },

  /**
   * Lấy phân loại đơn vị
   * @returns
   */
  async classificationType() {
    return await api.getClassificationType();
  },
};
const mutations = {
  ...crud.mutations,
  /**
   * Đồng bộ sang dữ liệu cache combo
   * @param {*} state
   * @param {*} items
   * NCPHUOC 07/12/2022
   */
  deleteItems: (state, items) => {
    crud.mutations.deleteItems(state, items);
    store.dispatch(`${ModuleAccountCombo}/deleteItemCombo`, items);
  },
  insertItem: (state, item) => {
    crud.mutations.insertItem(state, item);
    store.dispatch(`${ModuleAccountCombo}/insertItemCombo`, item);
    
    let defaults = store.getters[`${ModuleDefaultAccountCache}/items`] || [];
    let defaultDatas = defaults.filter(x => x.default_credit_account_id == item.old_account_number_reference || 
      x.default_debit_account_id == item.old_account_number_reference || x.default_tax_account_id == item.old_account_number_reference) || [];

    defaultDatas.forEach(element => {
      if(element.default_credit_account_id == item.old_account_number_reference){
        element.default_credit_account_id = item.account_number;
      }

      if(element.default_debit_account_id == item.old_account_number_reference){
        element.default_debit_account_id = item.account_number;
      }

      if(element.default_tax_account_id == item.old_account_number_reference){
        element.default_debit_account_id = item.account_number;
      }

      store.dispatch(`${ModuleDefaultAccountCache}/updateItemCombo`, item);
    });
  },
  updateItem: (state, item) => {
    crud.mutations.updateItem(state, item);
    store.dispatch(`${ModuleAccountCombo}/updateItemCombo`, item);

    if(item.is_update_parent){
      return;
    }

    let defaults = store.getters[`${ModuleDefaultAccountCache}/items`] || [];
    let defaultDatas = defaults.filter(x => x.default_credit_account_id == item.old_account_number_reference || 
      x.default_debit_account_id == item.old_account_number_reference || x.default_tax_account_id == item.old_account_number_reference) || [];

    
      defaultDatas.forEach(element => {
        if(element.default_credit_account_id == item.old_account_number_reference){
          element.default_credit_account_id = item.account_number;
        }

        if(element.default_debit_account_id == item.old_account_number_reference){
          element.default_debit_account_id = item.account_number;
        }

        if(element.default_tax_account_id == item.old_account_number_reference){
          element.default_debit_account_id = item.account_number;
        }

        // dư thừa thì cập nhật cả cột category
        if(!item.is_tranfer_data){
          if(element.default_debit_account_category_id?.includes(item.old_account_number_reference)){
            element.default_debit_account_category_id = element.default_debit_account_category_id.replace(item.old_account_number_reference, item.account_number);
          }
          if(element.default_credit_account_category_id?.includes(item.old_account_number_reference)){
            element.default_credit_account_category_id = element.default_credit_account_category_id.replace(item.old_account_number_reference, item.account_number);
          }
          if(element.default_tax_account_category_id?.includes(item.old_account_number_reference)){
            element.default_tax_account_category_id = element.default_tax_account_category_id.replace(item.old_account_number_reference, item.account_number);
          }
        }

        store.dispatch(`${ModuleDefaultAccountCache}/updateItemCombo`, item);
      });
  },
  updateItemQuickFllow: (state, item) => {
    crud.mutations.updateItemQuickFllow(state, item);
    store.dispatch(`${ModuleAccountCombo}/updateItemQuickFllowCombo`, item);
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
